import { debounce } from 'lodash'

import { useLatestCallback } from '@marketplace-web/shared/ui-state-util'
import {
  transformDynamicFilterOptions,
  CATALOG_FILTERS_SEARCH_DEBOUNCE_AMOUNT,
  getCatalogSearchedFilters,
} from '@marketplace-web/catalog/catalog-data'
import {
  useCatalogContext,
  DynamicFilterReducerAction,
} from '@marketplace-web/catalog/catalog-page-data'

const useFetchDynamicFilterSearch = () => {
  const { state, dispatch } = useCatalogContext()

  const fetchDynamicFilterSearch = async ({ text, code }) => {
    const { filters } = state
    const { selectedDynamicFilters } = state.dynamicFilters

    dispatch({
      type: DynamicFilterReducerAction.SET_FILTER_SEARCH_QUERY,
      payload: { text, code },
    })

    dispatch({
      type: DynamicFilterReducerAction.FETCH_DYNAMIC_FILTER_SEARCH_REQUEST,
      payload: undefined,
    })

    const response = await getCatalogSearchedFilters({
      ...filters,
      selectedDynamicFilters,
      filterSearchText: text,
      filterSearchCode: code,
    })

    if ('errors' in response) {
      dispatch({
        type: DynamicFilterReducerAction.FETCH_DYNAMIC_FILTER_SEARCH_FAILURE,
        payload: { errors: response.errors },
      })
    } else {
      dispatch({
        type: DynamicFilterReducerAction.FETCH_DYNAMIC_FILTER_SEARCH_SUCCESS,
        payload: {
          code,
          options: transformDynamicFilterOptions(response.options),
          isSelectionHighlighted: response.is_selection_highlighted,
        },
      })
    }
  }

  const debouncedFetchDynamicFilterSearch = useLatestCallback(
    debounce(fetchDynamicFilterSearch, CATALOG_FILTERS_SEARCH_DEBOUNCE_AMOUNT),
  )

  return debouncedFetchDynamicFilterSearch
}

export default useFetchDynamicFilterSearch
